import { DevicePlatformEnum, useSwitchCallMutation } from '@/types/generated/graphql';
import { useModal } from '@shared/hooks/use-modal';
import { notification } from 'antd';
import { useSwitchCallStore as switchCallStore } from '../store/use-switch-call.store';

export const useSwitchCallBanner = () => {
  const switchModal = useModal();
  const [switchCall, { loading }] = useSwitchCallMutation({
    onCompleted: (data) => {
      notification.success({ message: data.switchCall?.message });
      switchModal.handleClose();
      switchCallStore.setState({ showSwitchCall: false });
    },
    onError: (error) => {
      notification.error({ message: error.message });
      switchModal.handleClose();
    },
  });

  const handleSwitchCall = () => {
    const callId = switchCallStore.getState().callId;
    if (!callId) return;

    switchCall({
      variables: {
        switchCallId: callId,
        input: {
          destinationDevicePlatform: DevicePlatformEnum.web,
        },
      },
    });
  };

  return {
    loading,
    switchModal,
    handleSwitchCall,
  };
};
